import { useSearchParams } from 'react-router-dom'

export const associationKindOptions = [
  { value: 'real', label: 'Real' },
  { value: 'demo', label: 'Demo' },
]

export function usePlatformAssociationFilters() {
  const [params, setParams] = useSearchParams()
  const search = params.get('q') ?? ''
  const kind = params.get('kind') ?? ''
  const selected = new Set(kind.split(',').filter(Boolean))
  const query = new URLSearchParams()
  if (search) query.set('q', search)
  if (kind) query.set('kind', kind)
  const suffix = query.size ? `?${query}` : ''

  function change(key: string, value: string, replace = false) {
    setParams(
      (current) => {
        const next = new URLSearchParams(current)
        if (value) next.set(key, value)
        else next.delete(key)
        return next
      },
      { replace },
    )
  }

  function clear() {
    setParams((current) => {
      const next = new URLSearchParams(current)
      next.delete('q')
      next.delete('kind')
      return next
    })
  }

  return {
    search,
    selected,
    active: Boolean(search || kind),
    path: `/api/v1/platform/associations${suffix}`,
    changeSearch: (value: string) => change('q', value, true),
    changeKinds: (values: Set<string>) =>
      change(
        'kind',
        associationKindOptions
          .filter(({ value }) => values.has(value))
          .map(({ value }) => value)
          .join(','),
      ),
    clear,
  }
}
